import { defineComponent as h, openBlock as t, createElementBlock as a, mergeProps as m, unref as o, renderSlot as p, createElementVNode as e, createCommentVNode as i } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const V = { key: 0 }, Z = { key: 1 }, g = { key: 2 }, v = { key: 3 }, A = { key: 4 }, L = { key: 5 }, M = {
  name: "ScalarIconFramerLogo"
}, w = /* @__PURE__ */ h({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const r = H, { bind: s, weight: n } = u(r);
    return (d, l) => (t(), a("svg", m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(s)), [
      p(d.$slots, "default"),
      o(n) === "bold" ? (t(), a("g", V, l[0] || (l[0] = [
        e("path", { d: "M212,104V40a12,12,0,0,0-12-12H56a12,12,0,0,0-8,21L96.44,92H56a12,12,0,0,0-12,12v64a12,12,0,0,0,3.52,8.49l72,72A12,12,0,0,0,140,240V180h60a12,12,0,0,0,8-21l-48.41-43H200A12,12,0,0,0,212,104Zm-43.56,52H128a12,12,0,0,0-12,12v43L68,163V116h55.44ZM188,92H132.56l-45-40H188Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), a("g", Z, l[1] || (l[1] = [
        e("path", {
          d: "M200,104H128L56,40H200ZM56,168l72,72V168h72l-72-64H56Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M208,104V40a8,8,0,0,0-8-8H56a8,8,0,0,0-5.31,14L107,96H56a8,8,0,0,0-8,8v64a8,8,0,0,0,2.34,5.66l72,72A8,8,0,0,0,136,240V176h64a8,8,0,0,0,5.31-14L149,112h51A8,8,0,0,0,208,104Zm-29,56H128a8,8,0,0,0-8,8v52.69l-56-56V112h61Zm13-64H131L77,48H192Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), a("g", g, l[2] || (l[2] = [
        e("path", { d: "M200,112H149l56.27,50A8,8,0,0,1,200,176H136v64a8,8,0,0,1-13.66,5.66l-72-72A8,8,0,0,1,48,168V104a8,8,0,0,1,8-8h51L50.69,46A8,8,0,0,1,56,32H200a8,8,0,0,1,8,8v64A8,8,0,0,1,200,112Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), a("g", v, l[3] || (l[3] = [
        e("path", { d: "M206,104V40a6,6,0,0,0-6-6H56a6,6,0,0,0-4,10.48L112.22,98H56a6,6,0,0,0-6,6v64a6,6,0,0,0,1.76,4.24l72,72A6,6,0,0,0,134,240V174h66a6,6,0,0,0,4-10.48L143.78,110H200A6,6,0,0,0,206,104Zm-21.78,58H128a6,6,0,0,0-6,6v57.51l-60-60V110h63.72ZM194,98H130.28L71.78,46H194Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), a("g", A, l[4] || (l[4] = [
        e("path", { d: "M208,104V40a8,8,0,0,0-8-8H56a8,8,0,0,0-5.31,14L107,96H56a8,8,0,0,0-8,8v64a8,8,0,0,0,2.34,5.66l72,72A8,8,0,0,0,136,240V176h64a8,8,0,0,0,5.31-14L149,112h51A8,8,0,0,0,208,104Zm-29,56H128a8,8,0,0,0-8,8v52.69l-56-56V112h61Zm13-64H131L77,48H192Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), a("g", L, l[5] || (l[5] = [
        e("path", { d: "M204,104V40a4,4,0,0,0-4-4H56a4,4,0,0,0-2.66,7l64.14,57H56a4,4,0,0,0-4,4v64a4,4,0,0,0,1.17,2.83l72,72A4,4,0,0,0,132,240V172h68a4,4,0,0,0,2.66-7l-64.14-57H200A4,4,0,0,0,204,104Zm-14.52,60H128a4,4,0,0,0-4,4v62.34l-64-64V108h66.48ZM196,100H129.52l-63-56H196Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  w as default
};
